import { checkHasProjectFile } from "./checkHasProjectFile.js";
import { TSCONFIG_FILENAME } from "./constants.js";
const checkIsTypeScriptProject = async (args) => {
  return checkHasProjectFile({
    ...args,
    filename: TSCONFIG_FILENAME
  });
};
export {
  checkIsTypeScriptProject
};
//# sourceMappingURL=checkIsTypeScriptProject.js.map
